import { fromJS } from 'immutable';
import * as actions from '../../actions/equityFinder/dashboard';
import { fetchingState } from '../../constants';

const initialStats = {
  appraiserStatus: {},
  appraiserCase: {},
  appraisers: { data: [], state: null },
  recentEdits: {},
  hotList: {},
  protest: {},
  timeLines: {},
  timeLine: {},
  currentAppraiser: '',
  currentSupervisor: '',
  evidenceList: {},
  openRecentItemsState: false,
};

export default (state = fromJS(initialStats), action) => {
  switch (action.type) {
    case actions.APPRAISER_STATUS_FETCH_START:
      return state.setIn(['appraiserStatus', 'state'], fetchingState.FETCHING);
    case actions.APPRAISER_STATUS_FETCH_SUCCESS:
      let newState = state.setIn(
        ['appraiserStatus', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['appraiserStatus', 'data'],
        fromJS(action.data.results),
      );
    case actions.APPRAISER_STATUS_FETCH_ERROR:
      return state.setIn(['appraiserStatus', 'state'], fetchingState.ERROR);

    case actions.APPRAISERS_FETCH_START:
      return state.setIn(['appraisers', 'state'], fetchingState.FETCHING);
    case actions.APPRAISERS_FETCH_SUCCESS:
      newState = state.setIn(['appraisers', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['appraisers', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case actions.APPRAISERS_FETCH_ERROR:
      return state.setIn(['appraisers', 'state'], fetchingState.ERROR);

    case actions.RECENT_EDITS_FETCH_START:
      return state.setIn(['recentEdits', 'state'], fetchingState.FETCHING);
    case actions.RECENT_EDITS_FETCH_SUCCESS:
      newState = state.setIn(['recentEdits', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['recentEdits', 'data'],
        fromJS(action.data && action.data.results ? action.data.results : []),
      );
    case actions.RECENT_EDITS_FETCH_ERROR:
      return state.setIn(['recentEdits', 'state'], fetchingState.ERROR);

    case actions.HOT_LIST_FETCH_START:
      return state.setIn(['hotList', 'state'], fetchingState.FETCHING);
    case actions.HOT_LIST_FETCH_SUCCESS:
      newState = state.setIn(['hotList', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['hotList', 'data'],
        fromJS(action?.data?.results || []),
      );
    case actions.HOT_LIST_FETCH_ERROR:
      return state.setIn(['hotList', 'state'], fetchingState.ERROR);

    case actions.PROTEST_FETCH_START:
      return state.setIn(['protest', 'state'], fetchingState.FETCHING);
    case actions.PROTEST_FETCH_SUCCESS:
      newState = state.setIn(['protest', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['protest', 'data'],
        fromJS(action.data && action.data.results ? action.data.results : []),
      );
    case actions.PROTEST_FETCH_ERROR:
      return state.setIn(['protest', 'state'], fetchingState.ERROR);

    case actions.TIME_LINES_FETCH_START:
      return state.setIn(['timeLines', 'state'], fetchingState.FETCHING);
    case actions.TIME_LINES_FETCH_SUCCESS:
      newState = state.setIn(['timeLines', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['timeLines', 'data'],
        fromJS(action.data && action.data.results ? action.data.results : []),
      );
    case actions.TIME_LINES_FETCH_ERROR:
      return state.setIn(['timeLines', 'state'], fetchingState.ERROR);

    case actions.TIME_LINE_FETCH_START:
      return state.setIn(['timeLine', 'state'], fetchingState.FETCHING);
    case actions.TIME_LINE_FETCH_SUCCESS:
      newState = state.setIn(['timeLine', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['timeLine', 'data'],
        fromJS(action.data && action.data.results ? action.data.results : []),
      );
    case actions.TIME_LINE_FETCH_ERROR:
      return state.setIn(['timeLine', 'state'], fetchingState.ERROR);

    case actions.APPRAISER_CASE_FETCH_START:
      return state.setIn(['appraiserCase', 'state'], fetchingState.FETCHING);
    case actions.APPRAISER_CASE_FETCH_SUCCESS:
      newState = state.setIn(['appraiserCase', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['appraiserCase', 'data'],
        fromJS(action.data && action.data.results ? action.data.results : []),
      );
    case actions.APPRAISER_CASE_FETCH_ERROR:
      return state.setIn(['appraiserCase', 'state'], fetchingState.ERROR);

    case actions.EVIDENCE_FETCH_START:
      return state.setIn(['evidenceList', 'state'], fetchingState.FETCHING);
    case actions.EVIDENCE_FETCH_SUCCESS:
      newState = state.setIn(['evidenceList', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['evidenceList', 'data'],
        fromJS(action.data && action.data.results ? action.data.results : []),
      );
    case actions.EVIDENCE_FETCH_ERROR:
      return state.setIn(['evidenceList', 'state'], fetchingState.ERROR);

    case actions.CHANGE_CURRENT_APPRAISER:
      return state.set('currentAppraiser', action.data);

    case actions.CHANGE_CURRENT_SUPERVISOR:
      return state.set('currentSupervisor', action.data);

    case actions.TOGGLE_RECENT_ITEMS:
      return state.set(
        'openRecentItemsState',
        !state.get('openRecentItemsState'),
      );
    default:
      return state;
  }
};
